import { render } from "./PostsView.vue?vue&type=template&id=ee0d22a8"
import script from "./PostsView.vue?vue&type=script&lang=js"
export * from "./PostsView.vue?vue&type=script&lang=js"

import "./PostsView.vue?vue&type=style&index=0&id=ee0d22a8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__